import { Component, OnInit } from '@angular/core';
import { LoaderService } from '../../service/loader.service';
import { ChartService } from '../../service/chart.service';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { ReportAnalyticsService } from '../../service/report-analytics.service';
import { empty } from 'rxjs';

@Component({
  selector: 'app-orders-over-time',
  templateUrl: './orders-over-time.component.html',
  styleUrls: ['./orders-over-time.component.scss']
})
export class OrdersOverTimeComponent extends BaseComponent implements OnInit {

  period: number=0;
  chartData: number[]=[];
  chartLabel: string;
  months=[];
  //totalMonthlyOrder: number=0;
  showError: boolean=false;
  // public lineChartLabels:string[] =[]
   public lineChartLabels:any[] =[]
  public lineChartData:any[] =[];
  public lineChartType:string = 'line';
  public lineChartLegend:boolean = false;
  public lineChartColors:Array<any> = [];

  public lineChartOptions:any = {
    scaleShowVerticalLines: false,
    responsive: true 
  };
  
  colorCount:number;
  constructor( 
         private loaderService: LoaderService
        ,private chartService:ChartService
        ,private reportAnalyticsService:ReportAnalyticsService
      ){ 
        
        super();
  }

  ngOnInit(): void {
  }

    CreateChartSelectedDateWise(totalMonthlyOrder: any)  {
              
        this.lineChartData =[];
        this.chartData=[];
        this.chartLabel="";
        this.lineChartLabels=[];
      console.log("totalMonthlyOrder",totalMonthlyOrder);
        if (totalMonthlyOrder === "0"||totalMonthlyOrder === "" || totalMonthlyOrder === null || totalMonthlyOrder === undefined)
        {
            this.toastrAlertService.errorToastr(this.appTranslateService.getTranslate("pleaseEnterTotalMonthlyOrder"));
            return;
        }
          this.reportAnalyticsService.GetOrdersOverTimeReport(totalMonthlyOrder).subscribe(
          ress => {
            this.loaderService.hide();
            if (ress.successed) {
              var data = ress.data;
              this.lineChartData=[];              
                this.lineChartLegend=true;

                const customerColumn = data.customerReport.filter(
                  (customerReport, i, arr) => arr.findIndex(t => t.columnName === customerReport.columnName) === i
                );

              const monthsColumn = data.customerReport.filter(
                  (customerReport, i, arr) => arr.findIndex(t => t.subColumnName === customerReport.subColumnName) === i
                );


                for (let mc = 0; mc < monthsColumn.length; mc++) {                
                  this.lineChartLabels.push(monthsColumn[mc].subColumnName);
                }

                customerColumn.forEach((_data,_indexCust) => {                
                  const value: any[] = []; 
                  
                  monthsColumn.forEach((_dataMonth,_indexMonth) => {

                    const _filteredData = data.customerReport.filter(
                      item => item.columnName === _data.columnName 
                      && item.subColumnName===_dataMonth.subColumnName
                    );
                    
                      console.log("_filteredData",_filteredData);
                      if(_filteredData.length>0)
                      {
                          value.push(_filteredData[0].columnValue);
                      }
                      else
                      {
                          value.push(0);
                      }
                  });
                    this.chartLabel=_data.columnName;    

                    const filteredDatabyCustomer = data.customerReport.filter(
                      item => item.columnName === _data.columnName
                    );
            
                    
                    this.lineChartData.push(
                      {
                        label:this.chartLabel,
                        data:value,
                        borderColor: this.chartService.getColors(_indexCust),
                        fill: false
                      })

                });

              

              // this.lineChartData = [
                //   {
                //     label: 'receipt Real Estate LLC',
                //     data: [120, 150, 170, 140, 160, 180],
                //     borderColor: 'blue',
                //     fill: false
                //   },
                //   {
                //     label: 'Another Company',
                //     data: [100, 130, 160, 120, 150, 170],
                //     borderColor: 'gray',
                //     fill: false
                //   }
                // ];
              
              
                console.log("lineChartData",this.lineChartData);
                console.log("lineChartLabels",this.lineChartLabels);
                // //#region  lineChart
            
                // //#endregion

            
              } else {
              this.toastrAlertService.errorToastr(ress.errorMessage);
            }
          },
          error => {
            this.loaderService.hide();
            if (typeof error.error !== "undefined") {
              this.toastrAlertService.errorToastr(this.appTranslateService.getTranslate('generalError'));
            }
          }
          )
      this.lineChartData =[];
      this.chartData=[];
      this.lineChartLabels=[];
      this.lineChartData=[];
     
      this.loaderService.hide();
      
      
    }
    public chartClicked(e:any):void {
      //console.log(e);
    }

    public chartHovered(e:any):void {
      //console.log(e);
    }

    onlyNumbers(e) {
    if (e.key === "+") {
      return true;
    }
    const URL_REGEXP = /^[0-9]/;
    if (URL_REGEXP.test(e.key)) {
      return true;
    }
    e.preventDefault();
    return false;
  }
}
